import { Eye, X } from "lucide-react";
import { usePermissions } from "@/contexts/PermissionsContext";

/**
 * Top-banner shown while an admin is previewing the app as a different role.
 * Visual filter only — admin's API token is unchanged. Frontend `can()` will
 * report the previewed role's permissions, so sidebar items / buttons hide
 * exactly as they would for that role.
 */
export default function PreviewBanner() {
  const { isPreviewing, previewRole, clearPreview, registry } = usePermissions();
  if (!isPreviewing) return null;

  const meta = (registry || []).find((r) => r.key === previewRole);
  const label = meta?.label || previewRole;
  const color = meta?.color || "#a855f7";

  return (
    <div
      data-testid="preview-banner"
      className="flex items-center justify-between px-5 py-2 border-b border-amber-500/30 bg-gradient-to-r from-amber-500/10 via-amber-500/5 to-transparent text-amber-200 text-xs"
    >
      <div className="flex items-center gap-2 min-w-0">
        <Eye className="w-4 h-4 flex-shrink-0" />
        <span className="font-mono uppercase tracking-wider text-[10px] text-amber-400">Vorschau-Modus</span>
        <span className="hidden sm:inline text-zinc-300">— Sie sehen die App als</span>
        <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded bg-zinc-900 border border-zinc-800">
          <span className="w-2 h-2 rounded-full" style={{ background: color }} />
          <strong className="text-zinc-100">{label}</strong>
        </span>
        <span className="hidden md:inline text-zinc-500">. Ihre Anmeldung bleibt Admin — Aktionen werden weiterhin erlaubt.</span>
      </div>
      <button
        onClick={clearPreview}
        data-testid="preview-banner-exit"
        className="inline-flex items-center gap-1 px-2.5 py-1 bg-zinc-900 hover:bg-zinc-800 border border-zinc-700 hover:border-amber-500/40 text-zinc-200 hover:text-amber-200 rounded transition-colors flex-shrink-0"
      >
        <X className="w-3.5 h-3.5" /> Beenden
      </button>
    </div>
  );
}
